import { useCallback } from 'react'
import { useActivitiesContext } from '../../../../context'
import { closeContentActionCreator } from '@user/features/Activity/state'
import { useFormikContext } from 'formik'
import { getTouchedObject } from '@sales-center/common'
import { ActivityForm } from '../../typings'

export function useHandlers() {
  const [, dispatch] = useActivitiesContext()

  const { setTouched, errors, submitForm } = useFormikContext<ActivityForm>()

  const handleCancelClick = useCallback(() => {
    dispatch(closeContentActionCreator())
  }, [dispatch])

  const handleSaveClick = useCallback(() => {
    if (errors && Object.keys(errors).length > 0) {
      setTouched(getTouchedObject(errors))
    } else {
      submitForm()
    }
  }, [errors, setTouched, submitForm, getTouchedObject])

  return {
    handleCancelClick,
    handleSaveClick,
  }
}
